// Header.js
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';
import { FaBars } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Header = ({ toggleSidebar }) => {
  const { t, i18n } = useTranslation('sidebar');
  const [title, setTitle] = useState('');
  const location = useLocation();

  // map routes → translation keys
  const pathToKey = {
    '/overview': 'sidebar.header.dashboard',
    '/manage-services': 'sidebar.header.services',
    '/manage-staff': 'sidebar.header.staff',
    '/calendar': 'sidebar.header.calendar',
    '/roster': 'sidebar.header.roster',
    '/support': 'sidebar.header.support',
    '/payments': 'sidebar.header.payments',
    '/manage-site': 'sidebar.header.manageSite',
    '/online-booking': 'sidebar.header.manageOnlineBookings',
    '/settings': 'sidebar.header.settings',
    '/search': 'sidebar.header.search'
  };

  useEffect(() => {
    const key = pathToKey[location.pathname] || 'sidebar.header.fallback';
    setTitle(t(key));
  }, [location.pathname, t]); // re-run on route or language change

  const today = new Intl.DateTimeFormat(i18n.language || 'en', {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  }).format(new Date()).replace(/,/g, '');

  return (
    <header className="app-header">
      <div className="header-left">
        <button
          id="hamburger-toggle"
          className="hamburger-btn"
          onClick={toggleSidebar}
          aria-label={t('sidebar.header.menuAria')}
        >
          <FaBars />
        </button>
        <span className="header-title">{title}</span>
      </div>
      <div className="header-right">
        <span className="header-date">{today}</span>
      </div>
    </header>
  );
};

export default Header;
